import React from 'react';
import { css } from '@emotion/core';
import { Badge } from 'antd';
import { colors } from '../../constants';
import IconSvg from '../common/IconSvg';
import { buttonHover, buttonNormal } from '../../constants/themes';

export const Notifications = props => {
  return (
    <div
      css={css`
        &:hover {
          cursor: pointer;
        }
      `}
    >
      <Badge
        count={props.count}
        css={css`
          sup.ant-badge-count {
            background-color: ${colors.red};
          }
        `}
      >
        <IconSvg
          type="notifications-bell"
          color={buttonNormal}
          hoverColor={buttonHover}
          size={21}
        />
      </Badge>
    </div>
  );
};
